import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { image } from './../../../Helpers';

import './type-six.css';

/**
 * Type six
 *
 * @class TypeSix
 * @extends {Component}
 */
class TypeSix extends Component {
  /**
   * render
   *
   * @returns JSX
   * @memberof TypeSix
   */
  render() {
    return (
      <div className="history-type-six x-large">
        <div className="wrapper">
          {image(this.props.titulo, this.props.imagem)}
          
          {this.props.getInfo &&
            <div className="content">
              {this.props.getInfo(this.props.titulo, this.props.descricao)}
            </div>}
        </div>
      </div>
    )
  }
}

TypeSix.propTypes = {
  titulo: PropTypes.string.isRequired,
  imagem: PropTypes.object.isRequired,
  getInfo: PropTypes.func.isRequired,
  descricao: PropTypes.string,
}

export default TypeSix;